// extracted by mini-css-extract-plugin
module.exports = {"entry":"entry_entry__1jr6A"};